import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { SolverComponent } from '../../../solver';
import { SolverBlock } from '../../../model';

@Component({
  selector: 'dojo-solver-block-renderer',
  template: `<dojo-solver [solver]="block()" />`,
  styles: `
    :host {
      @apply block my-4;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SolverComponent],
})
export class SolverBlockRendererComponent {
  readonly block = input.required<SolverBlock>();
}
